var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6894 3.88235C18.9647 4.21176 18.1835 4.42824 17.3741 4.53176C18.2024 4.03294 18.8424 3.24235 19.1435 2.29176C18.3624 2.76235 17.4965 3.09176 16.5835 3.28C15.84 2.47059 14.7953 2 13.6094 2C11.3976 2 9.59059 3.80706 9.59059 6.03765C9.59059 6.35765 9.62824 6.66824 9.69412 6.96C6.34353 6.79059 3.36 5.18118 1.37412 2.74353C1.02588 3.33647 0.828235 4.03294 0.828235 4.76706C0.828235 6.16941 1.53412 7.41176 2.62588 8.11765C1.95765 8.11765 1.33647 7.92941 0.790588 7.64706V7.67529C0.790588 9.63294 2.18353 11.2706 4.02824 11.6376C3.43598 11.7997 2.81421 11.8223 2.21176 11.7035C2.46739 12.5059 2.96803 13.2079 3.64331 13.711C4.31858 14.2141 5.13454 14.4929 5.97647 14.5082C4.5493 15.6381 2.78023 16.2488 0.96 16.24C0.64 16.24 0.32 16.2212 0 16.1835C1.78824 17.3318 3.91529 18 6.19294 18C13.6094 18 17.6847 11.8447 17.6847 6.50824C17.6847 6.32941 17.6847 6.16 17.6753 5.98118C18.4659 5.41647 19.1435 4.70118 19.6894 3.88235Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_52"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.5316053322d1e2d1e55fb3d447fcddb1.svg";
export { ForwardRef as ReactComponent };